import { useEffect, useState } from 'react';
import { SchedulerSidebarCrew } from './crew';
import { SchedulerSidebarChanges } from './changes';
import { SchedulerSidebarDays } from './days';
import { SchedulerSidebarConfirmCrewAssignment } from './confirm/crewAssignment';
import { SchedulerSidebarConfirmCrewChanged } from './confirm/crewChanged';
import { useSchedulerSidebar } from '@contexts/scheduler/sidebar';
import { SchedulerSidebarContextData } from '@contexts/scheduler/sidebar/types';
import { cn } from '@utils/cn';
import { SchedulerSidebarEquipment } from './equipment';
import { SchedulerSidebarConfirmEquipmentAssignment } from './confirm/equipmentAssignment';
import { SchedulerSidebarConfirmEquipmentChanged } from './confirm/equipmentChanged';
import { useAccess } from '@hooks/access';
import { getSectionsGridRows } from './helpers';

export const SchedulerSidebar = () => {
  const [crewExpanded, setCrewExpanded] = useState(true);
  const access = useAccess();
  const { confirm, disabled, equipmentMembers } =
    useSchedulerSidebar() as SchedulerSidebarContextData;
  const hasEquipment = equipmentMembers.length > 0;
  const [equipmentExpanded, setEquipmentExpanded] = useState(hasEquipment);

  useEffect(() => {
    if (hasEquipment) setEquipmentExpanded(true);
  }, [hasEquipment]);
  const confirmPopupsVisible =
    confirm?.crewAssignment.open ||
    confirm?.crewChanged.open ||
    confirm?.equipmentAssignment.open ||
    confirm?.equipmentChanged.open;

  return (
    <div className="flex h-full max-h-full min-h-0 w-full bg-white border-t overflow-y-auto scrollbar-thin">
      <div className="flex h-full min-h-0 w-full flex-col">
        <div className={cn(confirmPopupsVisible ? 'shrink-0' : 'contents')}>
          <SchedulerSidebarConfirmCrewAssignment />
          <SchedulerSidebarConfirmCrewChanged />
          {!confirm?.crewAssignment.open && <SchedulerSidebarConfirmEquipmentAssignment />}
          {!confirm?.crewChanged.open && <SchedulerSidebarConfirmEquipmentChanged />}
        </div>
        <div className={cn('flex min-h-0 flex-1 flex-col', disabled && 'bg-neutral-50')}>
          <div
            className={cn(
              'grid min-h-0 flex-1 content-start',
              getSectionsGridRows(crewExpanded, equipmentExpanded),
            )}>
            <div
              className={cn(
                'flex min-h-0 flex-col',
                crewExpanded && 'overflow-hidden',
                disabled && 'bg-neutral-50',
              )}>
              <SchedulerSidebarCrew expanded={crewExpanded} onExpandedChange={setCrewExpanded} />
            </div>
            <div
              className={cn(
                'flex min-h-0 flex-col',
                equipmentExpanded && 'overflow-hidden',
                disabled && 'bg-neutral-50',
              )}>
              <SchedulerSidebarEquipment
                expanded={equipmentExpanded}
                onExpandedChange={setEquipmentExpanded}
              />
            </div>
          </div>
          {!access.readOnly && (
            <div
              className={
                crewExpanded || equipmentExpanded
                  ? 'max-h-[40%] min-h-0 shrink'
                  : 'mt-auto shrink-0'
              }>
              <SchedulerSidebarChanges />
              <SchedulerSidebarDays />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
